import styled from '@emotion/styled';

export const ActionsWrapper = styled.div`
    display: flex;
    flex-direction: column;

    button {
        padding-left: 6rem;
        padding-right: 6rem;
    }

    button + button {
        margin-top: 1rem;
    }

    button + small {
        margin-top: 0.5rem;
    }
`;
